import { css } from "lit";

export const style = css`
  :host {
    --radio-border-color: var(--_radio-border-color, var(--sbkRadiobuttonBorderOnLightEnabled));
    --radio-border-color-hover: var(--_radio-border-color-hover, var(--sbkRadiobuttonBorderOnLightHover));
    --radio-border-color-active: var(--_radio-border-color-active, var(--sbkRadiobuttonBorderOnLightActive));
    --radio-border-color-disabled: var(--_radio-border-color-disabled, var(--sbkRadiobuttonBorderOnLightDisabled));
    --radio-border-color-focus: var(--_radio-border-color-focus, var(--sbkRadiobuttonBorderOnLightFocus));
    --radio-border-color-error: var(--_radio-border-color-error, var(--sbkRadiobuttonBorderOnLightError));

    --radio-fg-color: var(--_radio-fg-color, var(--sbkRadiobuttonFgColorOnLightDefault));
    --radio-fg-color-hover: var(--_radio-fg-color-hover, var(--sbkRadiobuttonFgColorOnLightHover));
    --radio-fg-color-active: var(--_radio-fg-color-active, var(--sbkRadiobuttonFgColorOnLightActive));
    --radio-fg-color-disabled: var(--_radio-fg-color-disabled, var(--sbkRadiobuttonFgColorOnLightDisabled));
    --radio-fg-color-error: var(--_radio-fg-color-error, var(--sbkRadiobuttonFgColorOnLightError));

    --radio-bg-color: var(--_radio-bg-color, var(--sbkRadiobuttonBgColorOnLightEnabled));
    --radio-bg-color-hover: var(--_radio-bg-color-hover, var(--sbkRadiobuttonBgColorOnLightHover));
    --radio-bg-color-active: var(--_radio-bg-color-active, var(--sbkRadiobuttonBgColorOnLightHover));
    --radio-bg-color-disabled: var(--_radio-bg-color-disabled, var(--sbkRadiobuttonBgColorOnLightDisabled));
    --radio-bg-color-focus: var(--_radio-bg-color-focus, var(--sbkRadiobuttonBgColorOnLightFocus));
    --radio-bg-color-error: var(--_radio-bg-color-error, var(--sbkRadiobuttonBgColorOnLightError));
    width: fit-content;
  }

  .radio__wrapper {
    color: var(--radio-fg-color);
    display: flex;
    align-items: center;

    @media (hover: hover) and (pointer: fine) {
      &:hover:not(:focus-visible) {
        .radio__label {
          color: var(--radio-fg-color-hover);
        }

        .radio__icon {
          background-color: var(--radio-bg-color-hover);
          border: var(--radio-border-color-hover);
        }
      }
    }
  }

  .radio__wrapper--disabled {
    color: var(--radio-fg-color-disabled);

    .radio__icon {
      background-color: var(--radio-bg-color-disabled);
      border: var(--radio-border-color-disabled);
    }
    input[type="radio"] {
      &::before {
        background-color: var(--radio-fg-color-disabled);
      }
    }
  }

  .radio__wrapper--error {
    color: var(--radio-fg-color-error);
    .radio__icon {
      background-color: var(--radio-bg-color-error);
      border: var(--radio-border-color-error);
    }
    input[type="radio"] {
      &::before {
        background-color: var(--radio-fg-color-error);
      }
      &:focus-visible {
        outline: var(--radio-border-color-focus);
        outline-offset: max(2px, 0.15em);
      }
    }
  }

  .radio__icon {
    -webkit-appearance: none;
    appearance: none;
    background-color: var(--radio-bg-color);
    margin-left: 0;
    width: calc(var(--sbkRadiobuttonSm) + 4px);
    height: calc(var(--sbkRadiobuttonSm) + 4px);
    border: var(--radio-border-color);
    border-radius: 50%;
    display: grid;
    place-content: center;
    margin-top: 0;
      align-self: baseline;
  }

  input[type="radio"] {
    cursor: pointer;
    flex-shrink: 0;
  }

    input[type="radio"]::before {
        content: "";
        width: var(--sbkRadiobuttonXs);
        height: var(--sbkRadiobuttonXs);
        border-radius: 50%;
        transform: scale(0);
        transition: 60ms transform ease-in-out;
        background-color: var(--sbkRadiobuttonFgColorOnLightDefault);
    }

    input[type="radio"][checked]::before {
        transform: scale(1);
    }

    input[type="radio"]:focus-visible {
        outline: var(--radio-border-color-focus);
        outline-offset: max(2px, 0.15em);
    }

  @media print {
    input[type="radio"] {
      appearance: none;
      border: 2px solid var(--sbkColorContentFgColorOnLightDefault);
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: inline-block;
      position: relative;
    }

    input[type="radio"][checked] {
      border: 3px solid var(--sbkColorContentFgColorOnLightDefault);
    }

    input[type="radio"][checked]::after {
      content: '';
      width: 55%;
      height: 55%;
      border: 3px solid var(--sbkColorContentFgColorOnLightDefault);
      border-radius: 60%;
      position: absolute;
      top: 1px;
      left: 1px;
      box-shadow: inset 0 0 0 5px var(--sbkColorContentFgColorOnLightDefault);
    }
  }

  .radio__label {
    cursor: pointer;
    padding-left: var(--sbkRadiobutton2xs);
    &:focus-visible {
      color: var(--radio-fg-color-active);
    }
  }
`;